
import { Component, Vue } from "vue-property-decorator";
import { Field, Toast } from "vant";
import { Getter } from "vuex-class";
import { pxToVw } from "@/utils/pxToVw";
import {
  directRedemption,
  batchShip,
  pickUpGoods,
  batchDirectRedemption,
  getJoinGoodsList,
  saveStoreRemark
} from "@/api/jielong";
import { downloadUrl } from "@/utils/util";
const PLACEHOLDER = require("@/assets/images/shouyin/shopManage/shelf-manage.png");
import SearchBar from "@/components/SearchBar/index.vue";
@Component({
  components: {SearchBar},
})
export default class BatchOrder extends Vue {
  @Getter companyId!: string;
  @Getter bottomSafetyHeight!: number;

  showClassify = false;
  classify = [
    { label: '全部备注', value: '' },
    { label: '商家备注', value: 2 },
    { label: '客户备注', value: 1 }
  ];

  // 正式参数：存储value，请求后端用这个值
  currentType: string | number = '';
  // 弹窗临时缓存value
  tempValue: string | number = '';

  statusOptions = [
    { name: '全部', value: '', color: '#86909C', isTab: true }, // value对应的是订单状态
    { name: '待发货', value: '0', color: '#FD8305', isTab: true },
    { name: '待提货', value: '1', color: '#FD8305', isTab: true }
  ]
  curTab: any = ''
  // 订单商品数组
  orderList = []
  // 选中ID数组
  checkedList: string[] = []
  // 全选状态
  isAllChecked = false

  currentItem:any = {
    orderId: ''
  }
  orderIdList:any = [
    {
      orderId: ''
    }
  ]

  refreshing = false
  loading = false
  finished = false
  remark = ''
  showAdd = false // 商家备注弹窗
  // 缓存当前正在编辑的订单下标
  currentEditIndex = null
  getShow = false // 订单提货
  getCode = '' // 订单提货码
  sendShow = false // 订单发货弹窗
  sendAllShow = false // 顶大批量发货
  whiteOff = false // 订单核销
  whiteAllOff = false // 订单批量核销

  // 统一弹窗
  dialogType = ""
  dialogShow = false
  // 标题映射
  dialogTitleMap: Record<string, string> = {
    addRemark: "添加备注",
    get: "订单提货",
    send: "确认订单发货？",
    off: "确认订单直接核销？",
    sendAllShow: "确认订单批量发货？",
    whiteAllOff: "确认订单批量核销？"
  }

  
  params:any = {
    pageIndex: 1,
    pageSize: 10,
    joinActivityId: '',
    orderStatus:'1',  // 1待发货/提货， 2已发货/提货， -1已取消
    distributionType:'', // 1提货、2发货
    queryContent: "",   // 搜索关键词
    remarkType: "",  // 1客户备注 2商家备注
    goodsList: []
  };
  totalRecords = 0

  mounted() {
    this.params.joinActivityId = this.$route.query.joinActivityId as string
    // this.params.joinActivityId = '6a549d03639c1195c049a606'
    this.getJoinGoodsListData()
  }

  imageSrc (item) {
    if (!item.headImg) return PLACEHOLDER;
    const path = item.headImg;
    if (/^https?:\/\//i.test(path)) return path;
    const sftpUrl = this.$store.state.user.sftpUrl || "";
    if (sftpUrl) return sftpUrl + path;
    return downloadUrl(path);
  }

  computeSatus(item: any) {
    let statusText = ''
    if (item.orderStatus === -1) {
      statusText = '已取消'
    } else if (item.orderStatus === 1) {
      statusText = item.distributionType === 1 ? '待提货' : '待发货'
    } else if (item.orderStatus === 2) {
      statusText =  '已发货'
    } else if (item.orderStatus === 3) {
      statusText = '已提货'
    }
    return statusText
  }

  getJoinGoodsListData () {
    getJoinGoodsList({
      storeId: this.companyId,
      ...this.params,
      distributionType: this.params.distributionType
    })
      .then((res) => {
        console.log('订单数据', res)
        if (this.refreshing || this.params.pageIndex === 1) {
          this.orderList = [];
        }
        this.orderList = this.orderList.concat(res.data.records);
        this.totalRecords = res.data.totalRecords
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.refreshing = false;
      })
      .catch(() => {
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
  get dialogTitle() {
    return this.dialogTitleMap[this.dialogType] || ""
  }

  onlyNumber() {
    this.getCode = this.getCode.replace(/[^\d]/g, '');
  }

  /**
   * 打开弹窗
   * @param type 弹窗类型
   * @param item 单行订单对象（编辑备注/单条操作传入）
   * @param index 当前订单下标（仅备注编辑使用）
   */
  openDialog(type: string, item?: any, index?: number) {
    this.dialogType = type
    this.dialogShow = true

    // 打开弹窗按需初始化数据
    if (type === 'addRemark') {
      // 编辑备注回填原有内容
      this.currentEditIndex = index ?? null
      this.remark = item?.orderStoreRemark || ''
    }
    if (type === 'get') {
      this.getCode = ''
    }
    // 单条操作保存当前订单
    if (['send','off','get','addRemark'].includes(type)) {
      this.currentItem = item
    }
  }
  
  // 添加备注
  handleConfirm() {
    const name = this.remark.trim()
    // 非空校验
    if (!name) {
      this.$toast('请输入备注内容')
      return
    }
    if (this.currentEditIndex !== null) {
      // 将新备注赋值到对应订单
      this.orderList[this.currentEditIndex].orderStoreRemark = name
    }
    this.showAdd = false
    this.$toast.success('备注修改成功')
  }

  // 编辑商家备注
  editRemark(index: number) {
    this.currentEditIndex = index
    // 把原有备注回填到输入框
    this.remark = this.orderList[index].orderStoreRemark
    this.showAdd = true
  }

  handleCancel() {
    this.dialogShow = false
  }

  async handleAllConfirm() {
    const type = this.dialogType
    const selectedOrders = this.orderList.filter(item => this.checkedList.includes(item.orderId))
    const selectIds = this.checkedList

    if (type === 'off') {
      console.log('直接核销')
      directRedemption({
        orderId: this.currentItem.orderId
      }).then((res:any) => {
        this.dialogShow = false
        this.$toast.success('核销成功')
        this.getJoinGoodsListData()
      })
    } else if(type === 'send'){
      console.log('发货')
      batchShip({
        orderList: [{
          orderId: this.currentItem.orderId
        }]
      }).then((res:any) => {
        this.dialogShow = false
        this.$toast.success('发货成功')
        this.getJoinGoodsListData()
      })
    } else if (type === 'get') {
      console.log('提货')
      pickUpGoods({
        storeId: this.companyId,
        orderId: this.currentItem.orderId,
        joinActivityId: this.params.joinActivityId,
        pickUpCode: this.getCode
      }).then((res:any) => {
        this.dialogShow = false
        this.$toast.success('提货成功')
        this.getJoinGoodsListData()
      })
    } else if (type==='addRemark') {
      const name = this.remark.trim()
      // 非空校验
      if (!name) {
        this.$toast('请输入备注内容')
        return
      }
      if (this.currentEditIndex !== null) {
        this.orderList[this.currentEditIndex].orderStoreRemark = name
      }
      saveStoreRemark({
        storeId: this.companyId,
        orderId: this.currentItem.orderId,
        orderStoreRemark: this.orderList[this.currentEditIndex].orderStoreRemark
      }).then((res: any) => {
        this.dialogShow = false
        this.$toast.success('备注修改成功')
      })
    } else if (type ==='sendAllShow') {
      batchShip({
        orderList: this.orderIdList
      }).then((res:any) => {
        this.dialogShow = false
        this.$toast.success('发货成功')
        this.getJoinGoodsListData()
      })
    } else if (type === 'whiteAllOff') {
      batchDirectRedemption({
        orderList: this.orderIdList
      }).then((res:any) => {
        this.dialogShow = false
        this.$toast.success('核销成功')
        this.getJoinGoodsListData()
      })
    }
  }

  // 发货、提货、直接核销
  handleDialog(type: string, item: any) {
    this.currentItem = item
    if (type === 'off') {
      this.whiteOff = true
    } else if(type === 'send'){
      this.sendShow = true
    } else {
      this.getShow = true
    }
  }

  // 批量处理
  batchData(type: number) {
    // 前置：判断是否勾选订单
    if (this.checkedList.length === 0) {
      this.$toast('请勾选需要处理的订单')
      return
    }

    // 根据选中的goodsId，拿到完整选中的订单对象
    const selectedOrders = this.orderList.filter(item => this.checkedList.includes(item.orderId))
    console.log('selectedOrders', selectedOrders)
    this.orderIdList = selectedOrders.map(item => ({
      orderId: item.orderId
    }));
    // 提取所有选中订单的状态数组
    const statusArr = selectedOrders.map(item => item.orderStatus)

    if (type === 1) {
      // ========== 批量发货：必须至少有一个【待发货】状态 ==========
      // const hasSendStatus = statusArr.includes('待发货')
      const hasSendStatus = statusArr.includes(1)
      if (!hasSendStatus) {
        this.$toast('请至少勾选一条待发货订单，才可执行批量发货')
        return
      }
      this.openDialog('sendAllShow')
    } else {
      // ========== 批量核销：必须至少有一个【待提货】状态 ==========
      // const hasPickStatus = statusArr.includes('待提货')
      const hasPickStatus = statusArr.includes(1)
      if (!hasPickStatus) {
        this.$toast('请至少勾选一条待提货订单，才可执行批量核销')
        return
      }
      this.openDialog('whiteAllOff')
    }
  }

  handleAllCheck() {
    // 获取【当前本次接口返回】的所有订单goodsId
    const currentPageIds = this.orderList.map(item => item.orderId)
    this.isAllChecked = !this.isAllChecked
    if (this.isAllChecked) {
      // 勾选全选
      this.checkedList = [...currentPageIds]
    } else {
      // 取消全选
      this.checkedList = []
    }
  }
 
  get tabs () {
    return this.statusOptions.filter((item: any) => item.isTab)
  }

  changeTabs (tab: string) {
    console.log('changeTabs----', tab)
    const scrollEl = document.querySelector('.order-scroll')
    if(scrollEl) scrollEl.scrollTop = 0
    this.curTab = tab
    
    // 切换tab清空勾选
    this.checkedList = []
    this.isAllChecked = false
    // this.curTab === 0 待发货  1  待提货
    // distributionType  1提货、2发货
    if (!tab) {
      this.params.distributionType = ''
    } else {
      const tabVal = Number(tab)
      this.params.distributionType = tabVal === 0 ? 2 : 1
    }
    this.params.pageIndex = 1
     this.orderList = []
    this.getJoinGoodsListData()
  }

  onChange(){
    console.log('checkedList------', this.checkedList)
    const currentPageIds = this.orderList.map(item => item.orderId)
     if(currentPageIds.length === 0){
      this.isAllChecked = false
      return
    }
    // 判断：当前列表所有ID，是否全部存在于选中数组，自动同步全选框状态
    const allSelected = currentPageIds.every(id => this.checkedList.includes(id))
    this.$nextTick(()=>{
      this.isAllChecked = allSelected
      console.log('onChange', this.isAllChecked)
    })
  }

  // 根据value反向获取label，用于页面回显展示
  getCurrentLabel() {
    const target = this.classify.find(item => item.value === this.currentType)
    return target ? target.label : '全部备注';
  }

  onSearch() {
    console.log('传给后端的参数value：', this.currentType)
    this.getJoinGoodsListData()
  }

  // 打开弹窗：复制正式value到临时变量，实现选中回显高亮
  openClassify() {
    this.tempValue = this.currentType;
    this.showClassify = true;
  }

  // 取消关闭：currentType完全不变，上次选择的数据保留
  popupClose() {
    this.showClassify = false;
  }

  // 确认：临时value赋值给正式参数，生效
  confirmSelect() {
    this.currentType = this.tempValue;
    console.log('this.currentType', this.currentType)
    this.params.remarkType = this.tempValue as string
    this.showClassify = false;
    this.getJoinGoodsListData()
  }
    /**
   * 下拉刷新
   * */
  onRefresh () {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getJoinGoodsListData()
  }

  /**
   * 上拉加载更多
   */
  onLoad () {
    this.params.pageIndex++;
    this.getJoinGoodsListData();
  }
  get bottomSafetyHeightVw(): string {
    return this.bottomSafetyHeight ? pxToVw(this.bottomSafetyHeight) : pxToVw(12);
  }
}
